import { choicesFromEnum } from '../../../@helpers/choices-from-enum';

export enum LtvGradationType{
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export const LtvGradationChoices = choicesFromEnum(LtvGradationType);